"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylingSchema = void 0;
exports.StylingSchema = {
    "$id": "https://www.redbull.com/schemas/styling.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Styling",
    "description": "A styling is editorial information, that is used to indicate a preferred visualization of an image within a story on the Web.",
    "type": "object",
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:styling:[a-z0-9-]+:[a-z0-9-]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        },
        "type": {
            "type": "string",
            "pattern": "^rrn:styling:[a-z0-9-]+:[a-z0-9-]+$"
        },
        "attributes": {
            "type": "object",
            "properties": {
                "variation": {
                    "description": "A set of predefined variations, that affect the presentation of the header image, title and teaser on redbull.com (e.g.: Two-Fold, Full-Bleed, etc.).",
                    "type": "string"
                },
                "orientation": {
                    "description": "Orientation of an image (e.g.: landscape, portrait) within the story content.",
                    "type": "string"
                },
                "size": {
                    "description": "Size of an image (e.g.: S, M, L, XL) within the story content.",
                    "type": "string"
                },
                "displayType": {
                    "description": "The display type defines the representation format of an image gallery within the story content (e.g.: rail, grid, etc.).",
                    "type": "string"
                }
            }
        },
        "meta": {
            "type": "object",
            "properties": {
                "draft": {
                    "description": "The draft flag indicates that the styling is not yet published. Draft styles are not visible on redbull.com. Instead, they are only visible on the preview environment for editors to verify changes before publishing them.",
                    "type": "boolean"
                }
            }
        }
    },
    "required": [
        "id",
        "type",
        "attributes"
    ],
    "additionalProperties": false
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGluZy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbW9kdWxlcy9zdHlsaW5nLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGFBQWEsR0FBRztJQUMzQixLQUFLLEVBQUUscURBQXFEO0lBQzVELFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLFNBQVM7SUFDbEIsYUFBYSxFQUFFLCtIQUErSDtJQUM5SSxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUscUZBQXFGO1NBQ2pHO1FBQ0QsTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLHFDQUFxQztTQUNqRDtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixXQUFXLEVBQUU7b0JBQ1gsYUFBYSxFQUFFLHVKQUF1SjtvQkFDdEssTUFBTSxFQUFFLFFBQVE7aUJBQ2pCO2dCQUNELGFBQWEsRUFBRTtvQkFDYixhQUFhLEVBQUUsK0VBQStFO29CQUM5RixNQUFNLEVBQUUsUUFBUTtpQkFDakI7Z0JBQ0QsTUFBTSxFQUFFO29CQUNOLGFBQWEsRUFBRSxnRUFBZ0U7b0JBQy9FLE1BQU0sRUFBRSxRQUFRO2lCQUNqQjtnQkFDRCxhQUFhLEVBQUU7b0JBQ2IsYUFBYSxFQUFFLDJIQUEySDtvQkFDMUksTUFBTSxFQUFFLFFBQVE7aUJBQ2pCO2FBQ0Y7U0FDRjtRQUNELE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixPQUFPLEVBQUU7b0JBQ1AsYUFBYSxFQUFFLDhOQUE4TjtvQkFDN08sTUFBTSxFQUFFLFNBQVM7aUJBQ2xCO2FBQ0Y7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsSUFBSTtRQUNKLE1BQU07UUFDTixZQUFZO0tBQ2I7SUFDRCxzQkFBc0IsRUFBRSxLQUFLO0NBQzlCLENBQUEifQ==